<template>
  <v-dialog v-model="vendorDetailDialog" persistent fullscreen>
    <template v-slot:activator="{ attrs }">
      <p
        id="vendorDetailDialog"
        v-bind="attrs"
        @click="openVendorDetailDialog"
      ></p>
    </template>
    <div
      v-if="!loading"
      style="padding: 0; margin: auto; border-radius: 5px; background: white"
    >
      <v-card
        tile
        flat
        style="
        border-bottom: 2px solid rgba(0, 0, 0, 0.1);
        margin-bottom: 10px;
        display: flex;
        justify-content: space-between;
        position: sticky;
        top: 0;
        background: white;
        z-index: 5;
      "
      >
        <div
          style="
          display: flex;
          justify-content: center;
          align-items: center;
          margin-left: 10px;
        "
        >
          <v-toolbar-title class="overline">
            <p
              :style="
                `font-size:${
                  wWidth > 780 ? '20px' : '3vw'
                }; margin: 0; padding-left: 5px;`
              "
            >
              DETAIL VENDOR
            </p>
            <v-btn
              style="position: absolute; top: 5px; right: 20px;"
              x-small
              text
              color="grey darken-2"
              @click="closeDetailVendorDialog"
            >
              <v-icon small>mdi-arrow-left</v-icon> Kembali
            </v-btn>
          </v-toolbar-title>
        </div>
      </v-card>
      <div v-if="form != null">
        <v-stepper class="elevation-0" v-model="stepperElement" vertical>
          <v-stepper-step :complete="stepperElement > 0" step="0" editable>
            Informasi Umum Vendor
          </v-stepper-step>
          <v-stepper-content step="0">
            <v-form
              ref="stepOneForm"
              @submit.prevent="nextStep(0)"
              lazy-validation
              :disabled="loading"
            >
              <v-card elevation="0">
                <v-row style="padding: 15px" :no-gutters="!isEdit">
                  <!-- <v-col cols="12" md="9" style="padding: 0"></v-col> -->
                  <v-col cols="12" style="padding: 0">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                        >
                          Logo Perusahaan
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-file-input
                          ref="companyLogo"
                          :placeholder="form.logo != null ? form.logo : 'Pilih File'"
                          :append-icon="form.logo != null ? 'mdi-close' : 'mdi-paperclip'"
                          prepend-icon=""
                          outlined
                          clearable
                          @click:append="clearLogo"
                          @click:clear="clearLogo"
                          @change="(event) => uploadLogo(event)"
                        ></v-file-input>
                        <v-img
                          height="150"
                          aspect-ratio="1.7"
                          contain
                          cols="12"
                          lazy-src
                          :src="
                            `${getVendorDetail.urlPath}${form.logo}`
                          "
                          alt="Company Image: undetected"
                        >
                        </v-img>
                      </v-col>
                    </div>
                  </v-col>
                  <v-col cols="8" style="padding: 0">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                        >
                          Nama Perusahaan *
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-text-field
                          @keydown.enter.prevent
                          dense
                          :outlined="isEdit"
                          v-model="form.name"
                          :rules="rules.companyNameRules"
                        />
                      </v-col>
                    </div>
                  </v-col>
                  <v-col cols="4" style="padding: 0">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                        >
                          Kode Vendor
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-text-field
                          @keydown.enter.prevent
                          dense
                          v-model="form.code"
                          :outlined="isEdit"
                        />
                      </v-col>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4" style="padding: 0">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                        >
                          Jenis Usaha *
                        </p>
                      </v-col>
                      <v-col
                        cols="12"
                        style="
                        padding: 0;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin-bottom: 0;
                      "
                      >
                        <v-autocomplete
                          @keydown.enter.prevent
                          v-model="form.business_entity"
                          :items="dropdown.businessEntity"
                          :rules="rules.companyTypeRules"
                          style="margin: 0"
                          item-text="name"
                          item-value="id"
                          return-object
                          :outlined="isEdit"
                          dense
                          :clearable="isEdit"
                        ></v-autocomplete>
                      </v-col>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4" style="padding: 0">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                        >
                          Skala Perusahaan *
                        </p>
                      </v-col>
                      <v-col
                        cols="12"
                        style="
                        padding: 0;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin-bottom: 0;
                      "
                      >
                        <v-autocomplete
                          @keydown.enter.prevent
                          v-model="form.company_scale"
                          :rules="rules.companyScaleRules"
                          :items="dropdown.companyScale"
                          style="margin: 0"
                          item-text="name"
                          item-value="id"
                          return-id
                          :outlined="isEdit"
                          dense
                          :clearable="isEdit"
                        ></v-autocomplete>
                      </v-col>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4" style="padding: 0">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                        >
                          Tahun Berdiri
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-text-field
                          @keydown.enter.prevent
                          dense
                          :outlined="isEdit"
                          type="number"
                          v-model="form.year_founded"
                        />
                      </v-col>
                    </div>
                  </v-col>
                  <v-col cols="12" style="padding: 0">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                        >
                          Alamat Kantor *
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-textarea
                          @keydown.enter.prevent
                          dense
                          auto-grow
                          rows="1"
                          :outlined="isEdit"
                          v-model="form.address"
                          :rules="rules.addressRules"
                        />
                      </v-col>
                    </div>
                  </v-col>
                  <v-col cols="12" md="6" style="padding: 0">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                        >
                          Provinsi *
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-autocomplete
                          @keydown.enter.prevent
                          v-model="form.province"
                          :items="dropdown.province"
                          :rules="rules.provinceRules"
                          style="margin: 0"
                          item-text="name"
                          item-value="id"
                          return-object
                          :outlined="isEdit"
                          dense
                          :clearable="isEdit"
                        ></v-autocomplete>
                      </v-col>
                    </div>
                  </v-col>
                  <v-col cols="12" md="6" style="padding: 0">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                        >
                          Kota *
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-autocomplete
                          @keydown.enter.prevent
                          v-model="form.city"
                          :items="dropdown.city"
                          :rules="rules.cityRules"
                          style="margin: 0"
                          item-text="name"
                          item-value="id"
                          return-object
                          :outlined="isEdit"
                          dense
                          :clearable="isEdit"
                        ></v-autocomplete>
                      </v-col>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4" style="padding: 0">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                        >
                          Kode Pos *
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-text-field
                          @keydown.enter.prevent
                          dense
                          :outlined="isEdit"
                          v-model="form.zip_code"
                          :rules="rules.postCodeRules"
                        />
                      </v-col>
                    </div>
                  </v-col>
                  <v-col cols="6" md="4" style="padding: 0">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                        >
                          Lat
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-text-field
                          @keydown.enter.prevent
                          dense
                          :outlined="isEdit"
                          v-model="form.location_lat"
                          :rules="rules.latRules"
                        />
                      </v-col>
                    </div>
                  </v-col>
                  <v-col cols="6" md="4" style="padding: 0">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                        >
                          lng
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-text-field
                          @keydown.enter.prevent
                          dense
                          :outlined="isEdit"
                          v-model="form.location_long"
                          :rules="rules.lngRules"
                        />
                      </v-col>
                    </div>
                  </v-col>
                  <v-col cols="12" md="6" style="padding: 0">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                        >
                          No. Telepon 1 *
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-text-field
                          @keydown.enter.prevent
                          dense
                          :outlined="isEdit"
                          type="number"
                          v-model="form.phone1"
                          :rules="rules.phoneRules"
                        />
                      </v-col>
                    </div>
                  </v-col>
                  <v-col cols="12" md="6" style="padding: 0">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                        >
                          No. Telepon 2
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-text-field
                          @keydown.enter.prevent
                          dense
                          :outlined="isEdit"
                          type="number"
                          v-model="form.phone2"
                        />
                      </v-col>
                    </div>
                  </v-col>
                  <v-col cols="12" md="6" style="padding: 0">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                        >
                          Email *
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-text-field
                          @keydown.enter.prevent
                          dense
                          :outlined="isEdit"
                          v-model="form.email"
                          :rules="rules.emailRules"
                        />
                      </v-col>
                    </div>
                  </v-col>
                  <v-col cols="12" md="6" style="padding: 0">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                        >
                          Website (jika ada)
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-text-field
                          @keydown.enter.prevent
                          dense
                          :outlined="isEdit"
                          v-model="form.website"
                          :rules="rules.websiteRules"
                        />
                      </v-col>
                    </div>
                  </v-col>

                  <!--  -->
                  <v-col cols="12" md="6" style="padding: 0">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                        >
                          Klasifikasi *
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-autocomplete
                          @keydown.enter.prevent
                          v-model="form.classification"
                          :rules="rules.classificationRules"
                          :items="dropdown.classification"
                          style="margin: 0"
                          item-text="name"
                          item-value="id"
                          return-object
                          :outlined="isEdit"
                          dense
                          :clearable="isEdit"
                        ></v-autocomplete>
                      </v-col>
                    </div>
                  </v-col>
                  <v-col cols="12" md="6" style="padding: 0">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                        >
                          Sub-Klasifikasi
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-autocomplete
                          @keydown.enter.prevent
                          v-model="form.sub_classification"
                          :items="dropdown.subClassification"
                          :rules="rules.subClassificationRules"
                          style="margin: 0"
                          item-text="name"
                          item-value="id"
                          return-object
                          :outlined="isEdit"
                          dense
                          :clearable="isEdit"
                        ></v-autocomplete>
                      </v-col>
                    </div>
                  </v-col>

                  <v-col cols="12" md="6" style="padding: 0">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                        >
                          Rata-rata omset perusahaan
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-autocomplete
                          @keydown.enter.prevent
                          v-model="form.average_turnover"
                          :items="dropdown.averageTurnover"
                          style="margin: 0"
                          item-text="name"
                          item-value="id"
                          return-object
                          :outlined="isEdit"
                          dense
                          :clearable="isEdit"
                        ></v-autocomplete>
                      </v-col>
                    </div>
                  </v-col>
                  <v-col cols="12" md="6" style="padding: 0">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                        >
                          Wilayah cakupan layanan
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-autocomplete
                          @keydown.enter.prevent
                          v-model="form.service_coverage"
                          :items="dropdown.serviceCoverage"
                          style="margin: 0"
                          item-text="name"
                          item-value="id"
                          return-object
                          :outlined="isEdit"
                          dense
                          :clearable="isEdit"
                              small-chips
                              deletable-chips
                              multiple
                        ></v-autocomplete>
                      </v-col>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4" style="padding: 0">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                        >
                          PKP / NON PKP
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0;">
                        <v-radio-group
                          @keydown.enter.prevent
                          v-model="form.is_pkp"
                          style="
                            height: 45px;
                            position: relative;
                            top: -10px;
                          "
                        >
                          <div
                            class="d-flex justify-content-around align-content-between"
                          >
                            <div
                              style="
                                padding: 0;
                                justify-content: flex-start;
                                align-items: center;
                                display: flex;
                              "
                            >
                              <v-radio
                                :value="true"
                                style="margin: 0; height: 25px; padding: 0"
                              ></v-radio>
                              <p style="margin: 0; font-size: 12px">PKP</p>
                            </div>
                            <div
                              style="
                                padding: 0;
                                justify-content: flex-start;
                                align-items: center;
                                display: flex;
                                margin-left: 40px;
                              "
                            >
                              <v-radio
                                :value="false"
                                style="margin: 0; height: 25px; padding: 0"
                              ></v-radio>
                              <p style="margin: 0; font-size: 12px">NON PKP</p>
                            </div>
                          </div>
                        </v-radio-group>
                      </v-col>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4" style="padding: 0">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                        >
                          Jumlah Karyawan
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-autocomplete
                          @keydown.enter.prevent
                          v-model="form.current_employee"
                          :items="dropdown.currentEmployee"
                          style="margin: 0"
                          item-text="name"
                          item-value="id"
                          return-object
                          :outlined="isEdit"
                          dense
                          :clearable="isEdit"
                        ></v-autocomplete>
                      </v-col>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4" style="padding: 0">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                        >
                          Jumlah produk / SKU / Lini Bisinis
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-autocomplete
                          @keydown.enter.prevent
                          v-model="form.number_products"
                          :items="dropdown.numberProducts"
                          style="margin: 0"
                          item-text="name"
                          item-value="id"
                          return-object
                          :outlined="isEdit"
                          dense
                          :clearable="isEdit"
                        ></v-autocomplete>
                      </v-col>
                    </div>
                  </v-col>
                  <v-col cols="12" style="padding: 0">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                        >
                          Profil Perusahaan
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-textarea
                          @keydown.enter.prevent
                          dense
                          auto-grow
                          rows="3"
                          :outlined="isEdit"
                          v-model="form.about"
                        />
                      </v-col>
                    </div>
                  </v-col>
                  <v-col cols="12" md="3" style="padding: 0">
                    <div style="padding: 0 10px" class="d-flex align-center">
                        <p
                          style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                        >
                          Online Shop ?
                        </p>
                        <v-switch
                          :outlined="isEdit"
                          v-model="form.is_onlineshop"
                          @keydown.enter.prevent
                          inset
                          color="success"
                          style="margin-left: 25px"
                        ></v-switch>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4" style="padding: 0">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                        >
                          Status Review
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-autocomplete
                          @keydown.enter.prevent
                          v-model="form.review_status"
                          :items="[
                            {
                              id: 0,
                              name: 'Need Review'
                            },
                            {
                              id: 1,
                              name: 'Review Complete'
                            }
                          ]"
                          style="margin: 0"
                          item-text="name"
                          item-value="id"
                          return-id
                          :outlined="isEdit"
                          dense
                          :clearable="isEdit"
                        ></v-autocomplete>
                      </v-col>
                    </div>
                  </v-col>
                </v-row>
              </v-card>
              <div class="d-flex justify-content-between align-center mt-10">
                <v-btn
                  type="submit"
                  rounded
                  elevation="0"
                  color="primary"
                  class="white--text font-weight-bold"
                  style="font-size: 12px; width: 100%"
                  :loading="loading"
                >
                  Simpan Perubahan
                </v-btn>
              </div>
            </v-form>
          </v-stepper-content>
        </v-stepper>
      </div>
    </div>
    <v-card
      v-else
      class="mx-auto"
      width="100%"
      style="
      z-index: 99;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      position: fixed;
      top: 0;
      height: 100%;
      left: 0;
      right: 0;
      background: rgba(255, 255, 255, 0.9);
    "
    >
      <v-progress-circular :size="150" :width="10" color="blue" indeterminate
        >Loading...</v-progress-circular
      >
    </v-card>
  </v-dialog>
</template>
<script>
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
import buildType from '../../services/buildType'
// const env = process.env.VUE_APP_BUILD_TYPE
export default {
  name: 'vendorDetailDialog',
  components: {},
  props: ['act'],
  data() {
    return {
      procApi: buildType.apiURL('proc'),
      eSanqua: buildType.apiURL('esanqua'),
      oAuthApi: buildType.apiURL('oauth'),
      upload: buildType.apiURL('upload2'),
      build: process.env.VUE_APP_BUILD_TYPE,
      vendorDetailDialog: false,
      dialogForm: false,
      loading: false,
      isDisableCompanyDropdown: false,
      isEdit: false,
      stepperElement: 0,
      wWidth: window.innerWidth,
      isAllow: false,
      rules: {
        companyNameRules: [],
        companyTypeRules: [],
        addressRules: [],
        provinceRules: [],
        postCodeRules: [],
        latRules: [],
        lngRules: [],
        phoneRules: [],
        emailRules: [],
        companyScaleRules: [],
        classificationRules: [],
        subClassificationRules: []
      },
      dropdown: {
        province: [],
        city: [],
        classification: [],
        subClassification: [],
        averageTurnover: [
          {
            id: 1,
            name: '≤ Rp 2 Miliar (Usaha Mikro)'
          },
          {
            id: 2,
            name: '> Rp 2 Miliar – Rp 15 Miliar (Usaha Kecil)'
          },
          {
            id: 3,
            name: '> Rp 15 Miliar – Rp 50 Miliar (Usaha Menengah)'
          },
          {
            id: 4,
            name: '> Rp 50 Miliar (Usaha Besar)'
          }
        ],
        serviceCoverage: ['lokal', 'regional', 'nasional', 'internasional'],
        numberProducts: [
          {
            id: 1,
            name: '<5'
          },
          {
            id: 2,
            name: '5 - 10'
          },
          {
            id: 3,
            name: '>10'
          }
        ],
        currentEmployee: [
          {
            id: 1,
            name: '< 50 Orang'
          },
          {
            id: 2,
            name: '50 - 250 Orang'
          },
          {
            id: 3,
            name: '> 250 Orang'
          }
        ],
        businessEntity: [
          {
            id: '3',
            name: 'UD'
          },
          {
            id: '2',
            name: 'CV'
          },
          {
            id: '1',
            name: 'PT'
          },
          {
            id: '5',
            name: 'Koperasi'
          },
          {
            id: '6',
            name: 'Perorangan'
          },
          {
            id: '7',
            name: 'TB (Toko Bangunan)'
          },
          {
            id: '4',
            name: 'Lain - lain'
          }
        ],
        companyScale: [
          {
            id: 1,
            name: 'Kecil'
          },
          {
            id: 2,
            name: 'Menengah'
          },
          {
            id: 3,
            name: 'Besar'
          },
          {
            id: 4,
            name: 'Lain - lain'
          }
        ]
      },
      detailData: null,
      oldForm: null,
      form: null
    }
  },
  computed: {
    ...mapGetters(['getVendorDetail', 'getVendorId'])
  },
  async mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })

    this.dropdownClassification()
    this.dropdownProvince()
    this.setForm()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  watch: {
    'form.classification'() {
      // this.form.sub_classification = null
      if (this.form != null && this.form.classification != null) {
        if (
          this.form.classification.sub_classification != null &&
          this.form.classification.sub_classification.length > 0
        ) {
          this.dropdown.subClassification = this.form.classification.sub_classification
        }
      } else {
        this.dropdown.subClassification = []
        this.form.sub_classification = null
      }
    },
    'form.province'() {
      if (this.form != null && this.form.province != null) {
        if (
          this.form.province.city != null &&
          this.form.province.city.length > 0
        ) {
          this.dropdown.city = this.form.province.city
        }
      } else {
        this.dropdown.city = []
        this.form.city = null
      }
    }
  },
  methods: {
    ...mapActions(['detailVendor']),
    closeDetailVendorDialog() {
      this.vendorDetailDialog = false
      setTimeout(() => {
        this.setForm()
      }, 500)
    },
    openVendorDetailDialog() {
      if (this.act == 'update') {
        this.detailData = this.getVendorDetail
        this.setDetailToForm()
      } else {
        this.setForm()
      }
      setTimeout(() => {
        // this.startWatcher()
        this.vendorDetailDialog = true
      }, 500)
    },
    // saveEdit() {
    //   console.log('oldForm', this.oldForm)
    //   console.log('newForm', this.form)
    //   const changes = this.getChangedValues(this.oldForm, this.form)
    //   console.log('changes', changes)
    //   // if (changes.length > 0) {
    //   const formResult = {}

    //   changes.forEach(item => {
    //     // Skip field dengan [0]
    //     if (item.field.includes('[0]')) return

    //     const isObject = item.tipe_data === 'object'
    //     const isOldNull = item.old_value === null
    //     const isNewNull = item.new_value === null

    //     // CASE 1: object → null (hapus)
    //     if (isObject && isNewNull && typeof item.old_value === 'object') {
    //       const baseKey = item.field
    //       const oldObj = item.old_value

    //       for (const subKey in oldObj) {
    //         const subValue = oldObj[subKey]
    //         if (Array.isArray(subValue)) continue

    //         const fullKey = `${baseKey}_${subKey}`.replace(/\./g, '_')
    //         formResult[fullKey] = null
    //       }
    //       return
    //     }

    //     // CASE 2: null → object (tambah)
    //     if (isObject && isOldNull && typeof item.new_value === 'object') {
    //       const baseKey = item.field
    //       const newObj = item.new_value

    //       for (const subKey in newObj) {
    //         const subValue = newObj[subKey]
    //         if (Array.isArray(subValue)) continue

    //         const fullKey = `${baseKey}_${subKey}`.replace(/\./g, '_')
    //         const finalValue =
    //           subKey === 'name' && typeof subValue === 'string'
    //             ? subValue.toUpperCase()
    //             : subValue

    //         formResult[fullKey] = finalValue
    //       }
    //       return
    //     }

    //     // CASE 3: perubahan biasa (primitive to primitive)
    //     const formattedKey = item.field.replace(/\./g, '_')

    //     const keyParts = formattedKey.split('_')
    //     const lastKey = keyParts[keyParts.length - 1]

    //     const value =
    //       lastKey === 'name' && typeof item.new_value === 'string'
    //         ? item.new_value.toUpperCase()
    //         : item.new_value

    //     formResult[formattedKey] = value
    //   })

    //   console.log('formResult', formResult)
    //   this.createNewForm(formResult)
    //   // } else {
    //   //   this.showMsgDialog(
    //   //     'warning',
    //   //     'Tidak ada perubahan yang disimpan',
    //   //     false
    //   //   )
    //   // }
    // },
    // enableEdit() {
    //   this.isEdit = !this.isEdit

    //   if (this.isEdit) {
    //     this.oldForm = { ...this.form }
    //   } else {
    //     this.oldForm = null
    //   }
    // },
    onResize() {
      this.wWidth = window.innerWidth
    },
    showMsgDialog(pModalType, pStatusMsg, pBtnCancel) {
      return new Promise(resolve => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html: '<strong style="font-size:18px;">' + pStatusMsg + '</strong>',
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            cancelButtonText: 'No'
          })
          .then(r => {
            resolve(r)
          })
      })
    },
    nextStep(val) {
      const self = this
      if (val === 0) {
        this.rules.companyNameRules = [v => !!v || 'Company name is required']
        this.rules.companyTypeRules = [v => !!v || 'Company type is required']
        this.rules.addressRules = [v => !!v || 'Address is required']
        this.rules.provinceRules = [v => !!v || 'Province is required']
        this.rules.cityRules = [v => !!v || 'City is required']
        // // this.rules.postCodeRules = [(v) => !!v || 'Post code is required']
        this.rules.addressRules = [v => !!v || 'Address is required']
        // // this.rules.latRules = [(v) => !!v || 'Lat is required']
        // // this.rules.lngRules = [(v) => !!v || 'Lng is required']
        this.rules.phoneRules = [v => !!v || 'Company phone is required']
        this.rules.emailRules = [
          v => !!v || 'E-mail is required',
          v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
        ]
        // // this.rules.websiteRules = [(v) => !!v || 'Website is required']
        this.rules.companyScaleRules = [v => !!v || 'Company scale is required']
        this.rules.classificationRules = [
          v => !!v || 'Classification is required'
        ]
        setTimeout(function() {
          if (self.$refs.stepOneForm.validate()) {
            self.createNewForm(self.form)
          }
        })
      }
    },
    createNewForm(form) {
      const newForm = {}
      // gabungkan form dengan newForm
      Object.assign(newForm, {
        act: this.act,
        address: form.address,
        business_entity_id: form.business_entity != null ? form.business_entity.id : null,
        code: form.code,
        company_scale: form.company_scale,
        email: form.email,
        location_lat: form.location_lat,
        location_long: form.location_long,
        name: form.name,
        phone1: form.phone1,
        phone2: form.phone2,
        service_coverage: form.service_coverage,
        website: form.website,
        year_founded: form.year_founded,
        zip_code: form.zip_code,
        logo: form.logo,
        about: form.about,
        is_pkp: form.is_pkp,
        review_status: form.review_status,
        is_onlineshop: form.is_onlineshop
      })
      if (this.act == 'update') {
        Object.assign(newForm, {
          id: this.getVendorId
        })
      }
      if (form.average_turnover) {
        Object.assign(newForm, {
          average_turnover: form.average_turnover.id
        })
      }
      if (form.city) {
        Object.assign(newForm, {
          city_id: form.city.id
        })
      }
      if (form.province) {
        Object.assign(newForm, {
          province_id: form.province.id
        })
      }
      if (form.classification) {
        Object.assign(newForm, {
          classification_id: form.classification.id
        })
      }
      if (form.sub_classification) {
        Object.assign(newForm, {
          sub_classification_id: form.sub_classification.id
        })
      }
      if (form.current_employee) {
        Object.assign(newForm, {
          current_employee: form.current_employee.id
        })
      }
      if (form.number_products) {
        Object.assign(newForm, {
          number_products: form.number_products.id
        })
      }
      console.log('save>>>', newForm)
      this.saveChange(newForm)
    },
    async saveChange(form) {
      this.loading = true
      await axios
        .post(`${this.procApi}vendor/save`, form)
        .then(res => {
          console.log(res.data)
          this.loading = false
          if (res.data.status_code == '00') {
            this.showMsgDialog('success', res.data.status_msg, false)
            this.isEdit = false
            this.$emit('refreshPage')
            setTimeout(() => {
              this.vendorDetailDialog = false
            }, 300)
          } else {
            if (res.data.status_msg == 'Parameter value has problem') {
              let xFlag = false
              if (res.data.error_msg !== undefined) {
                if (res.data.error_msg !== null) {
                  if (res.data.error_msg.length > 0) {
                    this.showMsgDialog(
                      'error',
                      `${res.data.error_msg[0].msg} (${res.data.error_msg[0].value})`,
                      false
                    )
                  } else {
                    xFlag = true
                  }
                } else {
                  xFlag = true
                }
              } else {
                xFlag = true
              }

              if (xFlag) {
                this.showMsgDialog(
                  'error',
                  'Invalid input, Parameter value has problem',
                  false
                )
              }
            } else {
              this.showMsgDialog('error', res.data.status_msg, false)
            }
          }
        })
        .catch(err => {
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
          return (this.loading = false)
        })
    },
    // closeForm() {
    //   for (let i = 0; i < this.form.vendor_document.length; i++) {
    //     if (this.form.vendor_document[i].file != null) {
    //       this.clearFileUpload(i)
    //     }
    //   }
    //   setTimeout(() => {
    //     this.$refs.stepOneForm.reset()
    //     this.$refs.stepTwoForm.reset()
    //     this.$refs.stepThreeForm.reset()
    //     this.$refs.stepFourForm.reset()
    //     this.$refs.stepFiveForm.reset()
    //     setTimeout(() => {
    //       this.$router.push('/e-catalogue/vendor-registration')
    //       // this.dialogForm = false
    //     }, 100)
    //   }, 100)
    // },
    async dropdownCompany() {
      axios
        .get(`${this.eSanqua}master/universal/plant/dropdown`)
        .then(res => {
          this.dropdown.company = res.data.data
        })
        .catch(err => {
          console.log(err)
        })
    },
    async dropdownClassification() {
      await axios
        .get(
          `${this.procApi}master/classification/drop_down?order_by=name&order_type=asc&keyword=`
        )
        .then(res => {
          if (res.data.status_code === '00') {
            return (this.dropdown.classification = res.data.data)
          }
          return (this.dropdown.classification = [])
        })
        .catch(err => {
          console.log(err)
          return (this.dropdown.classification = [])
        })
    },
    async dropdownProvince() {
      await axios
        .get(
          `${this.procApi}master/province/drop_down?order_by=name&order_type=asc&keyword=`
        )
        .then(res => {
          if (res.data.status_code === '00') {
            return (this.dropdown.province = res.data.data)
          }
          return (this.dropdown.province = [])
        })
        .catch(err => {
          console.log(err)
          return (this.dropdown.province = [])
        })
    },
    async dropdownCity() {
      await axios
        .get(
          `${this.procApi}master/city/drop_down?order_by=name&order_type=asc&keyword=`
        )
        .then(res => {
          if (res.data.status_code === '00') {
            return (this.dropdown.city = res.data.data)
          }
          return (this.dropdown.city = [])
        })
        .catch(err => {
          console.log(err)
          return (this.dropdown.city = [])
        })
    },

    setDetailToForm() {
      const xData = { ...this.detailData }
      console.log('setDetailToForm>>>', xData)
      if (xData.province != null) {
        this.form.province = xData.province
        this.form.province.city = [xData.city]
        this.form.city = xData.city
        this.dropdown.city = [xData.city]
      }
      if (xData.classification != null) {
        this.form.classification = xData.classification
        this.form.classification.sub_classification = [xData.sub_classification]
        this.form.sub_classification = xData.sub_classification
        this.dropdown.subClassification = [xData.sub_classification]
      }
      if (xData.average_turnover) {
        this.form.average_turnover = this.dropdown.averageTurnover.find(({ id }) => id == xData.average_turnover)
      }
      if (xData.number_products) {
        this.form.number_products = this.dropdown.numberProducts.find(({ id }) => id == xData.number_products)
      }
      if (xData.current_employee) {
        this.form.current_employee = this.dropdown.currentEmployee.find(({ id }) => id == xData.current_employee)
      }

      this.form.code = xData.code
      this.form.address = xData.address
      this.form.location_lat = xData.location_lat
      this.form.location_long = xData.location_long
      this.form.zip_code = xData.zip_code
      this.form.email = xData.email
      this.form.phone1 = xData.phone1
      this.form.phone2 = xData.phone2
      this.form.company_scale = xData.company_scale
      this.form.business_entity = xData.business_entity
      this.form.name = xData.name
      this.form.year_founded = xData.year_founded
      this.form.website = xData.website
      this.form.service_coverage = xData.service_coverage
      this.form.logo = xData.logo
      this.form.about = xData.about
      this.form.is_pkp = xData.is_pkp
      this.form.review_status = xData.review_status
    },
    downloadFile(xItem) {
      console.log('download>>>', xItem)
      window.open(xItem.path + xItem.file, '_blank')
    },
    convertDate(raw) {
      let res = '-'
      if (raw != null && raw != undefined && raw != '' && raw != 0) {
        // res = new Date().toLocaleDateString()
        const date = new Date(raw)
        const local = date.toLocaleDateString('id')
        const split = local.split('/')
        const day = split[0].length == 1 ? '0' + split[0] : split[0]
        const month = split[1].length == 1 ? '0' + split[1] : split[1]
        const year = split[2]
        res = `${day}-${month}-${year}`
      }
      return res
    },
    showMsgDialog2(
      pModalType,
      pStatusMsg,
      pBtnCancel,
      pText,
      inputType,
      inputLabel
    ) {
      let additional = ''
      if (pText !== undefined) {
        additional = '<span style="font-size:12px;">' + pText + '</span>'
      }
      return new Promise(resolve => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html:
              additional +
              '<br/>' +
              '<strong style="font-size:18px;">' +
              pStatusMsg +
              '</strong>',
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            confirmButtonText: 'Submit',
            cancelButtonText: 'No',
            input: inputType == undefined ? 'textarea' : inputType,
            inputLabel:
              inputLabel == undefined
                ? 'Tolong isi keterangan pada kolom dibawah sebelum submit'
                : inputLabel,
            inputPlaceholder: 'Tulis disini...',
            inputAttributes: {
              'aria-label': 'Tulis disini'
            }
          })
          .then(r => {
            resolve(r)
          })
      })
    },
    getChangedValues(oldObj, newObj, path = '') {
      const changes = []

      // Gabungkan semua key dari old dan new
      const allKeys = new Set([
        ...Object.keys(oldObj || {}),
        ...Object.keys(newObj || {})
      ])

      for (const key of allKeys) {
        const fullPath = path ? `${path}.${key}` : key

        const oldVal = oldObj ? oldObj[key] : undefined
        const newVal = newObj ? newObj[key] : undefined

        const oldType = typeof oldVal
        const newType = typeof newVal

        if (Array.isArray(newVal) && Array.isArray(oldVal)) {
          // Compare arrays by index
          newVal.forEach((item, index) => {
            const oldItem = oldVal[index] || {}
            changes.push(
              ...this.getChangedValues(oldItem, item, `${fullPath}[${index}]`)
            )
          })
        } else if (
          newType === 'object' &&
          newVal !== null &&
          oldType === 'object' &&
          oldVal !== null
        ) {
          // Both are objects: recurse
          changes.push(...this.getChangedValues(oldVal, newVal, fullPath))
        } else {
          // If either value is primitive or null, compare directly
          const isChanged = oldVal !== newVal
          const isOldDefined = oldVal !== undefined

          if (isChanged && isOldDefined) {
            changes.push({
              field: fullPath,
              old_value: oldVal,
              new_value: newVal,
              // eslint-disable-next-line
              tipe_data: Array.isArray(oldVal)
                ? 'array'
                : oldVal === null
                ? typeof newVal // eslint-disable-line indent
                : typeof oldVal // eslint-disable-line indent
            })
          }
        }
      }

      return changes
    },
    async clearLogo() {
      const fileName = this.form.logo
      // this.form.vendor_document[index].file = null
      const data = {
        module: 'logo',
        file_name: fileName
      }
      const unlink = await axios
        .post(`${this.upload}procurement/vendor/unlink`, data)
        .then(res => {
          console.log('Unlink>>>>>', res)
          if (res.data.status_code === '00') {
            // this.showMsgDialog('success', res.data.status_msg, false)
            return '00'
          } else {
            // this.showMsgDialog('warning', res.data.status_msg, false)
          }
          this.form.logo = null
          return '-99'
        })
        .catch(err => {
          console.log(err)
          // this.showMsgDialog('error', err.message, false)
          this.form.logo = null
          return '-99'
        })
      return unlink
    },
    async uploadLogo(event) {
      let xFlag = false
      if (this.form.logo == null) {
        xFlag = true
      } else {
        const xClear = await this.clearFileDialog()
        console.log('xClear:', xClear)
        xFlag = true
      }
      console.log('Event:', event)
      if (xFlag) {
        if (event !== null) {
          if (event.size <= 1024 * 1024 * 1) {
            const data = new FormData()
            data.append('file', event)
            data.append('module', 'logo')
            // data.append('module', 'vendor')
            axios
              .post(`${this.upload}procurement/vendor`, data)
              .then(res => {
                if (res.data.status === true) {
                  this.showMsgDialog(
                    'success',
                    'File siap disimpan, Silahkan lanjutkan dengan klik tombol "simpan file"',
                    false
                  )
                  this.form.logo = res.data.data.name
                } else {
                  this.showMsgDialog('warning', res.data.message, false)
                }
              })
              .catch(err => {
                this.showMsgDialog('error', err.message, false)
              })
          } else {
            setTimeout(() => {
              this.showMsgDialog('warning', 'Max size = 1MB', false)
            }, 300)
          }
        }
      }
    },
    setForm() {
      this.form = {
        code: null,
        address: null,
        location_lat: null,
        location_long: null,
        zip_code: null,
        city: null,
        province: null,
        email: null,
        phone1: null,
        phone2: null,
        classification: null,
        sub_classification: null,
        company_scale: null,
        business_entity: null,
        name: null,
        year_founded: null,
        number_products: null,
        service_coverage: [],
        average_turnover: null,
        current_employee: null,
        logo: null,
        about: null,
        is_pkp: null,
        review_status: null
      }
      if (this.$refs.stepOneForm && this.$refs.stepOneForm != undefined) {
        this.$refs.stepOneForm.reset()
      }
    }
  }
}
</script>
